// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"163daaea","703":"b22f4f4f","787":"38115b94"}[chunkId] + ".chunk.js";
};